<template>
  <div id="NavWeb" class="nav-web">
<!--    <gjw-header-banner />-->
    <div class="nav-content">
      <span class="gjw-link" @click="toGjw">构件坞首页</span>
      <div class="nav-right">
        <div class="login-part">
          <el-dropdown v-if="user.name">
            <span class="el-dropdown-link">欢迎，{{user.name}}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><p @click="logout">退出登录</p></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-else class="login-text" @click="toLogin">登录/注册</div>
        </div>
        <div class="icons-part">
          <i class="gjw-iconfont gjw-icon-guangxiaoer" title="找广小二" @click="openRobot" />
          <i class="gjw-iconfont gjw-icon-fankui" title="写问题反馈" @click="toFeedback" />
          <i class="gjw-iconfont gjw-icon-bangzhu" title="看帮助文档" @click="toHelp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import GjwHeaderBanner from '../business/GjwHeaderBanner.vue'
export default {
  name: 'NavWeb',
  // components: { GjwHeaderBanner },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      userLogout: 'user/logout',
    }),
    toGjw() {
      window.location.href = `${process.env.VUE_APP_GJW_PORTAL_URL}`
    },
    toLogin() {
      this.$showLogin()
    },
    logout() {
      const dest = window.location.href
      this.userLogout({ dest })
    },
    async openRobot() {
      if (this.user.name) {
        const data = await this.$api.user.getLoginToken()
        document.querySelector('#gr-window iframe').contentWindow.postMessage({
          type: 'plugin-sso-login-token',
          loginToken: data
        }, '*')
      }
      window.GlodonRobotJsSDK.show()
    },
    toFeedback() {
      const url = encodeURI(`${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?source=Selection`)
      window.open(url, '_blank')
    },
    toHelp() {
      const url = `https://www.kdocs.cn/l/cnAh6xY3sbHR?from=docs`
      window.open(url, '_blank')
    },
  }
}
</script>

<style lang="less" scoped>
  .nav-web{
    // height: 40px;
    line-height: 40px;
    background: @theme-dark-bg;
    color: #C8CAD3;
  }
  .nav-content{
    /deep/ .el-dropdown{
      color: #C8CAD3;
    }
    width: 1310px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .nav-right{
    display: flex;
    flex-direction: row;
  }
  .icons-part{
    margin-left: 20px;
    i{
      font-size: 18px;
      cursor: pointer;
      margin-right: 10px;
    }
  }
  .gjw-link{
    cursor: pointer;
    &:hover{
      color: @theme-color;
    }
  }
  .login-text{
    cursor: pointer;
    &:hover{
      color: @theme-color;
    }
  }
</style>
